import React from "react";

const PriceCard = ({ product, activeOffer }) => {
  const offer = product?.product_details?.active_offer || (activeOffer?.is_discount_applied ? activeOffer : null);
  let itemPrice = product?.total_price;

  if (offer && offer.discount_percentage > 0 && product?.product_details?.selling_price) {
    const discountedUnit = Math.round(product.product_details.selling_price * (1 - offer.discount_percentage / 100));
    const calculatedTotal = discountedUnit * (product.quantity || 1);
    if (product.total_price && product.total_price < product.product_details.selling_price * (product.quantity || 1)) {
      itemPrice = Math.min(product.total_price, calculatedTotal);
    } else {
      itemPrice = calculatedTotal;
    }
  }

  return (
    <div key={product.id} className=" flex  justify-between  ">
      <p className=" text-gray-600 flex-1">
        {product.product_details.title} ({product.quantity}) {product.product_details.product_type}
      </p>

      <p className="text-lg ml-2">₹ {itemPrice}</p>
    </div>
  );
};

export default PriceCard;
